import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-1" }
const _hoisted_2 = ["aria-checked"]
const _hoisted_3 = { class: "flex-shrink-0" }
const _hoisted_4 = { class: "flex-grow-1 min-w-0 text-truncate" }
const _hoisted_5 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_6 = { class: "ps-2 text-end opacity-50" }
const _hoisted_7 = ["aria-checked", "onClick"]
const _hoisted_8 = { class: "flex-shrink-0" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "flex-grow-1 min-w-0 text-truncate" }
const _hoisted_11 = {
  key: 0,
  class: "flex-shrink-0"
}
const _hoisted_12 = { class: "ps-2 text-end opacity-50" }
const _hoisted_13 = {
  key: 0,
  class: "d-flex flex-column gap-1 ps-3"
}
const _hoisted_14 = ["aria-checked", "onClick"]
const _hoisted_15 = { class: "flex-shrink-0" }
const _hoisted_16 = {
  key: 1,
  class: "c-icon"
}
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "flex-grow-1 min-w-0 text-truncate" }
const _hoisted_19 = { class: "flex-shrink-0" }
const _hoisted_20 = {
  key: 0,
  class: "ps-2 text-end opacity-50"
}
const _hoisted_21 = ["aria-checked", "onClick"]
const _hoisted_22 = { class: "flex-shrink-0" }
const _hoisted_23 = {
  key: 1,
  class: "c-icon"
}
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "flex-grow-1 min-w-0 text-truncate" }
const _hoisted_26 = { class: "flex-shrink-0" }
const _hoisted_27 = {
  key: 0,
  class: "ps-2 text-end opacity-50"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = _resolveComponent("v-icon")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "c-listitem d-flex user-select-none gap-2",
      role: "radio",
      "aria-checked": _ctx.modelValue === '',
      onClick: _cache[0] || (_cache[0] = $event => (_ctx.$emit('update:modelValue', '')))
    }, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          class: "flex-shrink-0",
          name: "layers"
        })
      ]),
      _createElementVNode("div", _hoisted_4, _toDisplayString({ unread: _ctx.$t("all_unread"), starred: _ctx.$t("all_starred"), "": _ctx.$t("all_feeds") }[
            _ctx.filterSelected
          ]), 1 /* TEXT */),
      (_ctx.filterSelected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.stats.total[_ctx.filterSelected]), 1 /* TEXT */)
          ]))
        : _createCommentVNode("v-if", true)
    ], 8 /* PROPS */, _hoisted_2),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tree, (node) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: node.type === 'folder' ? 'folder:' + node.folder.id : 'feed:' + node.feed.id
      }, [
        (node.type === 'folder')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("div", {
                class: "c-listitem d-flex user-select-none gap-2",
                role: "radio",
                "aria-checked": _ctx.modelValue === 'folder:' + node.folder.id,
                onClick: $event => (_ctx.$emit('update:modelValue', 'folder:' + node.folder.id))
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", {
                    onClick: _withModifiers($event => (_ctx.$emit('toggle-folder', node.folder)), ["stop"]),
                    class: "p-2 m-n2"
                  }, [
                    (!node.folder.is_expanded)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          name: "chevron-right"
                        }))
                      : (node.folder.is_expanded)
                        ? (_openBlock(), _createBlock(_component_v_icon, {
                            key: 1,
                            name: "chevron-down"
                          }))
                        : _createCommentVNode("v-if", true)
                  ], 8 /* PROPS */, _hoisted_9)
                ]),
                _createElementVNode("div", _hoisted_10, _toDisplayString(node.folder.title), 1 /* TEXT */),
                (_ctx.filterSelected)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.stats.folders[node.folder.id]?.[_ctx.filterSelected]), 1 /* TEXT */)
                    ]))
                  : _createCommentVNode("v-if", true)
              ], 8 /* PROPS */, _hoisted_7),
              (node.folder.is_expanded && node.feeds.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(node.feeds, (feedNode) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'feed:' + feedNode.feed.id,
                        class: "c-listitem d-flex user-select-none gap-2",
                        role: "radio",
                        "aria-checked": _ctx.modelValue === 'feed:' + feedNode.feed.id,
                        onClick: $event => (_ctx.$emit('update:modelValue', 'feed:' + feedNode.feed.id))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          (!feedNode.feed.icon)
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 0,
                                class: "flex-shrink-0",
                                name: "rss"
                              }))
                            : (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                _createElementVNode("img", {
                                  src: feedNode.feed.icon,
                                  alt: "",
                                  loading: "lazy"
                                }, null, 8 /* PROPS */, _hoisted_17)
                              ]))
                        ]),
                        _createElementVNode("div", _hoisted_18, _toDisplayString(feedNode.feed.title), 1 /* TEXT */),
                        _createElementVNode("div", _hoisted_19, [
                          (_ctx.filterSelected)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(_ctx.stats.feeds[feedNode.feed.id]?.[_ctx.filterSelected]), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                          (!_ctx.filterSelected && _ctx.feedErrors[feedNode.feed.id])
                            ? (_openBlock(), _createBlock(_component_v_icon, {
                                key: 1,
                                class: "flex-shrink-0",
                                title: _ctx.feedErrors[feedNode.feed.id],
                                name: "alert-circle"
                              }, null, 8 /* PROPS */, ["title"]))
                            : _createCommentVNode("v-if", true)
                        ])
                      ], 8 /* PROPS */, _hoisted_14))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]))
                : _createCommentVNode("v-if", true)
            ], 64 /* STABLE_FRAGMENT */))
          : (node.type === 'feed')
            ? (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "c-listitem d-flex user-select-none gap-2",
                role: "radio",
                "aria-checked": _ctx.modelValue === 'feed:' + node.feed.id,
                onClick: $event => (_ctx.$emit('update:modelValue', 'feed:' + node.feed.id))
              }, [
                _createElementVNode("div", _hoisted_22, [
                  (!node.feed.icon)
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 0,
                        class: "flex-shrink-0",
                        name: "rss"
                      }))
                    : (_openBlock(), _createElementBlock("span", _hoisted_23, [
                        _createElementVNode("img", {
                          src: node.feed.icon,
                          alt: "",
                          loading: "lazy"
                        }, null, 8 /* PROPS */, _hoisted_24)
                      ]))
                ]),
                _createElementVNode("div", _hoisted_25, _toDisplayString(node.feed.title), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_26, [
                  (_ctx.filterSelected)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.stats.feeds[node.feed.id]?.[_ctx.filterSelected]), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true),
                  (!_ctx.filterSelected && _ctx.feedErrors[node.feed.id])
                    ? (_openBlock(), _createBlock(_component_v_icon, {
                        key: 1,
                        class: "flex-shrink-0",
                        title: _ctx.feedErrors[node.feed.id],
                        name: "alert-circle"
                      }, null, 8 /* PROPS */, ["title"]))
                    : _createCommentVNode("v-if", true)
                ])
              ], 8 /* PROPS */, _hoisted_21))
            : _createCommentVNode("v-if", true)
      ], 64 /* STABLE_FRAGMENT */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}